// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__19UvG","header":"ReportDetails_header__1q3Uz","title":"ReportDetails_title__3c0ox","left":"ReportDetails_left__dVx__"};